import React from 'react';
import { MenuAction, SelectSection } from '@ordr-as/umami-react/context-menu';
import { Item } from '@ordr-as/umami-react/form';
import { FormattedMessage } from 'react-intl';
import { useQueryLocations } from '../../hooks/useLocationApi';
import { useNavigate, useLocation } from 'react-router-dom';
import LocationIcon from '@ordr-as/icons/LocationIcon';

const locationsPageRoute = '/locations';

const LocationPicker = () => {
  const navigate = useNavigate();
  const { data: locations, isSuccess } = useQueryLocations();
  const location = useLocation();

  const shouldUseLocationsPage = locations && locations.length > 5;

  const currentLocationId = location.pathname.split('/')[1]!;
  const currentLocationName = locations && locations.find((loc) => loc.locationId === currentLocationId)?.name;

  if (!isSuccess) {
    return <></>;
  }

  if (!shouldUseLocationsPage) {
    return (
      <SelectSection selectedKeys={[currentLocationId]} onAction={(key) => navigate(`/${key}`)}>
        {locations.map((location) => (
          <Item key={location.locationId}>{location.name}</Item>
        ))}
      </SelectSection>
    );
  }

  return (
    <MenuAction className="border-b border-grey-lightest" onClick={() => navigate(locationsPageRoute)}>
      {currentLocationName ? (
        <>
          <div className="flex gap-3 items-center mr-3">
            <LocationIcon width={20} height={20} color="#1D1D1D" />
            <span className="text-base text-brand-black">
              <FormattedMessage id="header.changeLocation" />
            </span>
          </div>
          <span className="text-sm text-grey-dark truncate max-w-[33vw]">{currentLocationName}</span>
        </>
      ) : (
        <FormattedMessage id="header.changeLocation" />
      )}
    </MenuAction>
  );
};

export default LocationPicker;
